import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img, { FluidObject } from 'gatsby-image';

import styles from './image-asset.module.css';

interface ImageAssetProps {
  contentfulId: string;
  description?: string;
  title?: string;
}

export const ImageAsset = ({
  contentfulId,
  description,
  title,
}: ImageAssetProps) => {
  const data = useStaticQuery<GatsbyTypes.ImageAssetQuery>(graphql`
    query ImageAsset {
      allContentfulAsset(
        filter: { file: { contentType: { regex: "image/" } } }
      ) {
        edges {
          node {
            contentful_id
            localFile {
              childImageSharp {
                fluid(maxWidth: 1076, toFormat: JPG) {
                  ...GatsbyImageSharpFluid_withWebp
                  presentationWidth
                }
              }
            }
          }
        }
      }
    }
  `);

  const fluid = data.allContentfulAsset.edges.find(
    (n) => n.node.contentful_id === contentfulId
  )?.node.localFile?.childImageSharp?.fluid;

  return (
    <figure
      className={styles.figure}
      style={{ maxWidth: fluid?.presentationWidth as number }}
    >
      <Img
        fluid={fluid as FluidObject}
        alt={description || title}
        title={title}
        className={styles.imageContainer}
      />
      {description && (
        <figcaption className={styles.figcaption}>{description}</figcaption>
      )}
    </figure>
  );
};
